import {
  MarketInvestmentsRoutesEnum,
  StoreInvestmentsRoutesEnum
} from 'investments/common/enums'

export const MARKET_INVESTMENTS_PRODUCTS_OFFERS_ROUTE =
  MarketInvestmentsRoutesEnum.PRODUCTS_OFFERS

export const INVESTMENTS_ROUTES = [
  '/cofrinhos/quer-guardar-dinheiro',
  '/cofrinhos/sem-ofertas-disponiveis',
  '/cofrinhos/como-quer-guardar',
  '/cofrinhos/guardar-dinheiro/por-valor',
  '/cofrinhos/guardar-dinheiro/por-valor/confira-os-dados',
  '/cofrinhos/guardar-dinheiro/por-valor/informe-seu-pin',
  '/cofrinhos/guardar-dinheiro/por-recebimentos',
  '/cofrinhos/guardar-dinheiro/por-recebimentos/confira-os-dados',
  '/cofrinhos/guardar-dinheiro/por-recebimentos/informe-seu-pin',
  '/cofrinhos/investimentos/depositar',
  '/cofrinhos/investimentos/depositar/confira-os-dados',
  '/cofrinhos/investimentos/depositar/informe-seu-pin',
  '/cofrinhos/investimentos/meus-investimentos',
  '/cofrinhos/investimentos/meus-investimentos/produtos',
  MARKET_INVESTMENTS_PRODUCTS_OFFERS_ROUTE,
  '/cofrinhos/investimentos/produtos/${pid}',
  '/cofrinhos/investimentos/resgatar/selecione-um-investimento',
  '/cofrinhos/investimentos/resgatar',
  '/cofrinhos/investimentos/resgatar/informe-seu-pin',
  '/investimentos/sobre-tributacao',
  '/cofrinhos/produtos/alterar-produto',
  '/cofrinhos/produtos/${pid}',
  '/cofrinhos',
  '/cofrinhos/objetivos/criar',
  '/cofrinhos/objetivos/${bid}',
  '/cofrinhos/objetivos/${bid}/produtos/${pid}',
  '/cofrinhos/objetivos/${bid}/produtos',
  '/cofrinhos/objetivos/${bid}/extrato',
  '/cofrinhos/guardar-dinheiro/selecione-um-objetivo',
  '/cofrinhos/objetivos/${bid}/alterar',
  '/cofrinhos/resgatar-dinheiro',
  '/cofrinhos/resgatar-dinheiro/selecione-um-produto',
  '/cofrinhos/resgatar-dinheiro/selecione-um-objetivo',
  '/cofrinhos/resgatar-dinheiro/informe-seu-pin',
  '/cofrinhos/regras',
  '/cofrinhos/regras',
  '/cofrinhos/regras/alterar/por-valor',
  '/cofrinhos/regras/alterar/por-recebimentos',
  '/cofrinhos/simulador',
  ...Object.values(StoreInvestmentsRoutesEnum)
] as const
